<template>
  <div class="full-text-review-progress-and-results">
    <stage-card-progress-bar
      title="Reviewed"
      other-tooltip-prefix="Unreviewed:"
      :total-count="totalCount"
      success-tooltip-prefix="Reviewed:"
      :success-count="reviewedCount"
      light-success-tooltip-prefix="Partially Reviewed:"
      :light-success-count="partiallyReviewedCount"
      error-tooltip-prefix="Conflicted:"
      :error-count="conflictedCount"
    />
    <screening-results-pills
      :outcome-summary="outcomeSummary"
      full-text-results
    />
  </div>
</template>

<script>
import StageCardProgressBar from './StageCardProgressBar';
import ScreeningResultsPills from './ScreeningResultsPills';
import { Review } from '@/models';

export default {
  name: 'FullTextReviewProgressAndResults',
  components: { StageCardProgressBar, ScreeningResultsPills },
  props: {
    review: {
      type: Review,
      required: true,
    },
  },
  computed: {
    progressSummary() {
      return this.review.fullTextReviewScreeningProgressSummary;
    },
    outcomeSummary() {
      return this.review.fullTextReviewScreeningOutcomeSummary;
    },
    reviewedCount() {
      return this.progressSummary?.screenedCount ?? 0;
    },
    partiallyReviewedCount() {
      return this.progressSummary?.partiallyScreenedCount ?? 0;
    },
    conflictedCount() {
      return this.progressSummary?.conflictedScreenCount ?? 0;
    },
    totalCount() {
      return this.progressSummary?.totalReferenceCount() ?? 0;
    },
  },
};
</script>

<style lang="scss" scoped>
.full-text-review-progress-and-results {
  display: grid;
  gap: 12px;
}
</style>
